// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + chunkId + "." + {"240":"86d630785993e305a67d","604":"b2a2be9e1aab166b8e58","795":"9d8836a2e4d094b02a6b","953":"a9086d95a5baf0b12970"}[chunkId] + ".js";
};